module.exports = "<layout-map></layout-map>\r\n"